import { v4 as uuidv4 } from 'uuid';
import { toast } from 'react-toastify';

// src/utils.js
// Qui puoi mettere tutte le tue utilità comuni
export function showError(errorMessages) {
    if (Array.isArray(errorMessages) && errorMessages.length) {
        toast.error(errorMessages.join('\n'));
    } else {
        toast.error(errorMessages)
    }
}

// Verifica se l'utente ha il ruolo di "Referente principale"
export function isReferentePrincipale(user){
    return user?.roles?.includes('Referente principale');
}

export function ucwords(string) {
    return string.toLowerCase().replace(/(^\w|\s\w)/g, m => m.toUpperCase());
}

//questa funzione Calcola l'altezza dinamicamente in base a vista header e agli elementi fixed
export function getFixedHeight() {
    const header = document.querySelector('.vista-header');
    const headerApp = document.querySelector('header.header');
    const appBar = document.querySelector('.app-bar');
    const itemContent = document.querySelector('.item-content');
    const headerAppHeight = headerApp ? headerApp.offsetHeight : 0;
    const appBarHeight = appBar ? appBar.offsetHeight + 16 : 0;// 16px per il padding sotto l'appbar
    const fixedAppHeight = headerAppHeight + appBarHeight + 5 + (itemContent ? 20 : 0);// 5px come padding sopra l'appbar
    return header ? (header.offsetHeight + fixedAppHeight + 20) : fixedAppHeight;
}

//recupera il device id dalla localStorage o lo crea se non esiste
export function getOrCreateDeviceId() {
    let deviceId = localStorage.getItem("device_id");
    if (!deviceId) {
        deviceId = uuidv4(); // Usa libreria UUID
        localStorage.setItem("device_id", deviceId);
    }
    return deviceId;
}

/**
 * Esegue una funzione asincrona con retry automatico
 * @param {Function} fetchFunction - La funzione da eseguire
 * @param {boolean} ignore - Indica se deve ignorare gli errori (ad esempio se il componente è smontato)
 * @param {Object} options - Opzioni di configurazione
 * @param {number} options.maxRetries - Numero massimo di tentativi (default: 3)
 * @param {number} options.baseDelay - Delay base in ms (default: 500) 
 */
export async function fetchWithRetry(fetchFunction, ignore, options = {}) {
    const {
        maxRetries = 3,
        baseDelay = 500
    } = options;

    let lastError;

    const shouldRetryFn = (error, attempt) => {
        // Non riprovare se il componente è stato smontato
        if (ignore) return false;
        // Riprova solo per errori di rete, non per errori 401/403
        return !error.message.includes('401') && !error.message.includes('403');
    }
    
    for (let attempt = 0; attempt <= maxRetries; attempt++) {
        try {
            return await fetchFunction();
        } catch (error) {
            lastError = error;
            
            // Se è l'ultimo tentativo o non dovremmo riprovare, lancia l'errore
            if (attempt === maxRetries || !shouldRetryFn(error, attempt)) {
                throw error;
            }
            
            // Calcola il delay
            const delay = baseDelay * Math.pow(2, attempt);
                
            console.log(`Tentativo ${attempt + 1} fallito, riprovo tra ${delay}ms:`, error.message);
            
            // Aspetta prima del prossimo tentativo
            await new Promise(resolve => setTimeout(resolve, delay));
        }
    }
    
    throw lastError;
}

// In futuro potrai aggiungere altre funzioni qui, per non frammentare in troppi file